<template>
  <div id="components-layout-demo-basic" class="head_">
    <a-layout>
      <a-layout-sider class="head_side">
        <img class="left_img" :src="product.detailImgUrl" alt="img" />
      </a-layout-sider>
      <a-layout>
        <a-layout-header class="head_up">
          <div class="head_up_title">{{ product.productName }}</div>
          <div @click="handleCopy" class="head_up_share">
            <img class="share_" src="../../../assets/image/share.png" alt="share" />
            <span>转发</span>
          </div>
        </a-layout-header>
        <a-layout-content class="head_middle letter_">
          {{ product.productSale }}

          <div class="develop_">
          </div>
        </a-layout-content>
        <a-layout-footer class="head_down">
          <div class="head_down_1">
            <div
              v-for="(item, index) in product.productTag"
              :key="index"
              class="child_"
            >
              {{ item }}
            </div>
          </div>
          <div class="head_down_2">本产品由{{ product.underCompany }}承保</div>
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default:()=>{}
    },
  },
  data() {
    return {
      visible: false,
      codeUrl: "",
      myPro: {},
    };
  },
  mounted() {
  },
  methods: {
    queryProductType(newVal) {
      let data = {
        productCode: newVal.code,
      };
      this.$api.queryProductType(data).then((res) => {
        this.createQueryCode(res.data.data);
      });
    },
    createQueryCode(type) {
      let templ = "index";
      if ("SURGICAL_INSURANCE" === type) {
        //手术险
        templ = "operate/index";
      }
      let origin = "http://front.run4wd.com/m/";
      let URL = window.location.href;
      if (URL.indexOf("cps.ssish") > -1) {
        origin = "http://yutaieb.com/m/";
      }
      let params = URL.split("?")[1];
      let qrUrl = origin + templ + "?" + params;
      
      import("jr-qrcode").then((jrQrcode) => {
        var imgBase64 = jrQrcode.getQrBase64(qrUrl);
        this.codeUrl = imgBase64;
      });
    },
    handleCopy() {
      import("clipboard-copy").then((copy) => {
        
        copy.default(window.location.href).then(() => {
          this.$message.success("产品链接已复制成功！");
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.head_ {
  border: 1px solid #f0f0f0;
  .head_side {
    flex: none !important;
    max-width: none !important;
    width: 25% !important;
    .left_img {
      //   height: auto;
      height: 100%;
      width: 100%;
    }
  }
  .head_up {
    background: none;
    display: flex;
    justify-content: space-between;
    .head_up_title {
      font-size: 23px;
      font-family: Microsoft YaHei UI;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .head_up_share {
      font-size: 13px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      display: flex;
      align-items: center;
      cursor: pointer;
      .share_ {
        width: 13px;
        height: auto;
        margin-right: 5px;
      }
    }
  }
  .head_middle {
    width: 88%;
    margin-left: 50px;
    text-align: left;
    font-size: 12px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  .develop_ {
    float: right;
  }
  .head_down {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;
    padding-top: 8px;

    .head_down_1 {
      width: 68%;
      display: flex;
      flex-flow: wrap;
      padding-bottom: 8px;
      .child_ {
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: rgba(254, 143, 45, 1);
        border: 1px solid rgba(254, 143, 45, 1);
        padding: 3px 6px;
        margin-right: 20px;
        margin-top: 8px;
      }
    }
    .head_down_2 {
      padding-bottom: 8px;
      font-size: 12px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
</style>
